// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"b203d32c","209":"b729764e","787":"5eac5758","829":"085f5453","878":"302a11e4"}[chunkId] + ".chunk.js";
};